import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00358 = new TileLayer({
  title: 'Máscara 19940906',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19940906l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00358.setVisible(false);

const layer00357 = new TileLayer({
  title: 'Máscara 19941024',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19941024l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00357.setVisible(false);

const layer00356 = new TileLayer({
  title: 'Máscara 19941125',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19941125l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00356.setVisible(false);

const layer00355 = new TileLayer({
  title: 'Máscara 19941211',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19941211l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00355.setVisible(false);

const layer00354 = new TileLayer({
  title: 'Máscara 19950112',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19950112l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00354.setVisible(false);

const layer00353 = new TileLayer({
  title: 'Máscara 19950402',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19950402l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00353.setVisible(false);

const layer00352 = new TileLayer({
  title: 'Máscara 19950418',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19950418l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00352.setVisible(false);

const layer00351 = new TileLayer({
  title: 'Máscara 19950520',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19950520l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00351.setVisible(false);

const layer00350 = new TileLayer({
  title: 'Máscara 19950621',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19950621l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00350.setVisible(false);

const layer00349 = new TileLayer({
  title: 'Máscara 19950723',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19950723l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00349.setVisible(false);

const layer00348 = new TileLayer({
  title: 'Máscara 19950824',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19950824l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00348.setVisible(false);

export const grupoCapa01_27 = new LayerGroup({
  title: 'Ciclo Hidrológico 1994-1995',
  fold: 'close',
  layers: [layer00348, layer00349, layer00350, layer00351, layer00352, layer00353, layer00354, layer00355, layer00356, layer00357, layer00358]
});